package linkerpangoquipdb

import app.cash.sqldelight.Query
import app.cash.sqldelight.SuspendingTransacterImpl
import app.cash.sqldelight.db.QueryResult
import app.cash.sqldelight.db.SqlCursor
import app.cash.sqldelight.db.SqlDriver
import kotlin.Any
import kotlin.Long
import kotlin.String

public class UserQueries(
  driver: SqlDriver,
) : SuspendingTransacterImpl(driver) {
  public fun <T : Any> selectAll(mapper: (
    id: String?,
    email: String?,
    name: String?,
    avatar: String?,
    updated_at: Long?,
  ) -> T): Query<T> = Query(-1_191_744_679, arrayOf("user_table"), driver, "User.sq", "selectAll", "SELECT user_table.id, user_table.email, user_table.name, user_table.avatar, user_table.updated_at FROM user_table") { cursor ->
    mapper(
      cursor.getString(0),
      cursor.getString(1),
      cursor.getString(2),
      cursor.getString(3),
      cursor.getLong(4)
    )
  }

  public fun selectAll(): Query<User_table> = selectAll(::User_table)

  public fun <T : Any> select(id: String?, mapper: (
    id: String?,
    email: String?,
    name: String?,
    avatar: String?,
    updated_at: Long?,
  ) -> T): Query<T> = SelectQuery(id) { cursor ->
    mapper(
      cursor.getString(0),
      cursor.getString(1),
      cursor.getString(2),
      cursor.getString(3),
      cursor.getLong(4)
    )
  }

  public fun select(id: String?): Query<User_table> = select(id, ::User_table)

  public fun <T : Any> selectByEmail(email: String?, mapper: (
    id: String?,
    email: String?,
    name: String?,
    avatar: String?,
    updated_at: Long?,
  ) -> T): Query<T> = SelectByEmailQuery(email) { cursor ->
    mapper(
      cursor.getString(0),
      cursor.getString(1),
      cursor.getString(2),
      cursor.getString(3),
      cursor.getLong(4)
    )
  }

  public fun selectByEmail(email: String?): Query<User_table> = selectByEmail(email, ::User_table)

  public fun <T : Any> selectCurrentUser(mapper: (
    id: String?,
    email: String?,
    name: String?,
    avatar: String?,
    updated_at: Long?,
  ) -> T): Query<T> = Query(360_411_804, arrayOf("user_table", "auth_table"), driver, "User.sq", "selectCurrentUser", "SELECT user_table.id, user_table.email, user_table.name, user_table.avatar, user_table.updated_at FROM user_table WHERE id = (SELECT user_id FROM auth_table ORDER BY created_at DESC LIMIT 1)") { cursor ->
    mapper(
      cursor.getString(0),
      cursor.getString(1),
      cursor.getString(2),
      cursor.getString(3),
      cursor.getLong(4)
    )
  }

  public fun selectCurrentUser(): Query<User_table> = selectCurrentUser(::User_table)

  /**
   * @return The number of rows updated.
   */
  public suspend fun insert(
    id: String?,
    email: String?,
    name: String?,
    avatar: String?,
    updated_at: Long?,
  ): Long {
    val result = driver.execute(74_396_389, """INSERT INTO user_table (id, email, name, avatar, updated_at) VALUES (?, ?, ?, ?, ?)""", 5) {
          var parameterIndex = 0
          bindString(parameterIndex++, id)
          bindString(parameterIndex++, email)
          bindString(parameterIndex++, name)
          bindString(parameterIndex++, avatar)
          bindLong(parameterIndex++, updated_at)
        }.await()
    notifyQueries(74_396_389) { emit ->
      emit("user_table")
    }
    return result
  }

  /**
   * @return The number of rows updated.
   */
  public suspend fun update(
    email: String?,
    name: String?,
    avatar: String?,
    updated_at: Long?,
    id: String?,
  ): Long {
    val result = driver.execute(null, """UPDATE user_table SET email = ?, name = ?, avatar = ?, updated_at = ? WHERE id ${ if (id == null) "IS" else "=" } ?""", 5) {
          var parameterIndex = 0
          bindString(parameterIndex++, email)
          bindString(parameterIndex++, name)
          bindString(parameterIndex++, avatar)
          bindLong(parameterIndex++, updated_at)
          bindString(parameterIndex++, id)
        }.await()
    notifyQueries(419_342_581) { emit ->
      emit("user_table")
    }
    return result
  }

  /**
   * @return The number of rows updated.
   */
  public suspend fun delete(id: String?): Long {
    val result = driver.execute(null, """DELETE FROM user_table WHERE id ${ if (id == null) "IS" else "=" } ?""", 1) {
          var parameterIndex = 0
          bindString(parameterIndex++, id)
        }.await()
    notifyQueries(-77_269_545) { emit ->
      emit("user_table")
    }
    return result
  }

  /**
   * @return The number of rows updated.
   */
  public suspend fun deleteAll(): Long {
    val result = driver.execute(165_521_482, """DELETE FROM user_table""", 0).await()
    notifyQueries(165_521_482) { emit ->
      emit("user_table")
    }
    return result
  }

  private inner class SelectQuery<out T : Any>(
    public val id: String?,
    mapper: (SqlCursor) -> T,
  ) : Query<T>(mapper) {
    override fun addListener(listener: Query.Listener) {
      driver.addListener("user_table", listener = listener)
    }

    override fun removeListener(listener: Query.Listener) {
      driver.removeListener("user_table", listener = listener)
    }

    override fun <R> execute(mapper: (SqlCursor) -> QueryResult<R>): QueryResult<R> = driver.executeQuery(null, """SELECT user_table.id, user_table.email, user_table.name, user_table.avatar, user_table.updated_at FROM user_table WHERE id ${ if (id == null) "IS" else "=" } ?""", mapper, 1) {
      var parameterIndex = 0
      bindString(parameterIndex++, id)
    }

    override fun toString(): String = "User.sq:select"
  }

  private inner class SelectByEmailQuery<out T : Any>(
    public val email: String?,
    mapper: (SqlCursor) -> T,
  ) : Query<T>(mapper) {
    override fun addListener(listener: Query.Listener) {
      driver.addListener("user_table", listener = listener)
    }

    override fun removeListener(listener: Query.Listener) {
      driver.removeListener("user_table", listener = listener)
    }

    override fun <R> execute(mapper: (SqlCursor) -> QueryResult<R>): QueryResult<R> = driver.executeQuery(null, """SELECT user_table.id, user_table.email, user_table.name, user_table.avatar, user_table.updated_at FROM user_table WHERE email ${ if (email == null) "IS" else "=" } ?""", mapper, 1) {
      var parameterIndex = 0
      bindString(parameterIndex++, email)
    }

    override fun toString(): String = "User.sq:selectByEmail"
  }
}
